import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Shipping = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">Shipping & Reurns</small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col md={3} xl={3}>
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Faq_Cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9} className="shipping_spacing px-5">
              <Card className=" Shipping_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Shipping | Digtial Delivery</b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4">
                  <p>
                    <b className="text_muted">
                      Seamless Digital Delivery for Your Convenience
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      At LibertyPrograms.com, we are committed to providing a
                      hassle-free and efficient purchasing experience. With our
                      Digital Delivery policy, you gain immediate access to your
                      purchases, making the process quick and convenient.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      Instant Access to Your Purchases:
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      Once your purchase is complete, you will gain instant
                      access to your products within your Liberty Software
                      account area. No need to wait for shipping or worry about
                      delivery times. Your purchased items will be readily
                      available for download and activation, allowing you to
                      start enjoying them without delay.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      Online Digital Download and Licensing:
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      All our products, including download media and licensing
                      keys, are provided exclusively through online digital
                      download. This streamlined approach ensures that you can
                      access your software swiftly, eliminating the need for
                      physical shipments.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      Order Receipt and PDF Download Instructions:
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      Upon completing your purchase, you will receive an order
                      receipt for your records. This receipt serves as
                      confirmation of your transaction and provides essential
                      details about your purchase. Additionally, you will
                      receive clear and concise PDF download instructions,
                      guiding you through the process of downloading and
                      installing your software.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      Enjoy the Benefits of Digital Delivery:
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      Our Digital Delivery policy offers bc n benefits,
                      including immediate access to your purchases, reduced wait
                      times, and environmentally friendly practices without the
                      need for physical shipments. We strive to make your buying
                      experience as seamless as possible.
                      <br />
                      <br />
                      Should you have any questions or require assistance with
                      your digital delivery, our dedicated customer support team
                      is available to provide the guidance you need.
                      <br />
                      <br />
                      Thank you for choosing LibertyPrograms.com, where quick
                      and convenient digital delivery is our priority.
                    </p>
                  </div>
                </Card.Body>
              </Card>

              <Card className="Shipping_Card box_shadow mt-5">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Return Policy </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4">
                  <p>
                    <b className="text_muted">
                      Refunds for Unused License Keys - 90-Day Satisfaction
                      Guarantee
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      At Liberty Programs, we want to ensure your satisfaction
                      with our products. If you have purchased an electronic
                      delivery product and have not yet revealed the license key
                      in your account area, we offer a 90-day refund policy. If
                      the condition of the license key remaining unrevealed in
                      your account area is met, we will provide an immediate
                      refund upon request.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">Refund Processing Timeframe:</b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      Accepted refunds will be processed promptly within 1-2
                      weeks. We strive to process refunds as quickly as possible
                      to ensure a smooth experience for our customers.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">Verification and Eligibility:</b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      To maintain the integrity of our products, Liberty
                      Programs will perform a verification process to ensure
                      that the product's license key has not been activated or
                      tampered with. Once this verification process is complete
                      and the product is deemed eligible, we will refund the
                      purchase price using the original method of payment.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      License Key Activation and Refund Eligibility:
                    </b>
                  </p>
                  <div className="Shipping_Card_text">
                    <p className="black_text">
                      Please note that if the license key has been used to
                      install the software you have purchased, we will be unable
                      to process a refund. It is important to ensure that the
                      license key remains unused to maintain eligibility for a
                      refund.
                    </p>
                    <p className="black_text">
                      In the rare event that the license key does not work to
                      activate the software you have purchased, we are committed
                      to providing a new license key promptly to rectify the
                      situation.
                    </p>
                    <p className="black_text">
                      Our goal is to deliver high-quality products and ensure
                      customer satisfaction. If you have any questions or
                      concerns regarding our refund policy, please contact our
                      customer support team, and we will be happy to assist you.
                    </p>
                  </div>
                  <p>
                    <b className="text_muted">
                      Thank you for choosing Liberty Programs.
                    </b>
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Shipping;
